import { Routes, Route, useNavigate } from 'react-router-dom';
import {
  CarrierList,
  CarrierFormsList,
  FormEditorPage,
  NewFormPage,
} from '@/features/quote-and-apply-builder';
import { CompositeTemplatesPage } from '@/features/quote-and-apply-builder/components/composite-templates-page';

function CarrierListPage() {
  const navigate = useNavigate();

  return (
    <CarrierList
      onNewForm={() => navigate('new')}
      onSelectCarrier={carrier => navigate(String(carrier.insuranceCarrierId))}
    />
  );
}

export function FormBuilder() {
  return (
    <Routes>
      <Route
        index
        element={<CarrierListPage />}
      />
      <Route
        path=":carrierId"
        element={<CarrierFormsList />}
      />
      <Route
        path=":carrierId/:formId/composite-templates"
        element={<CompositeTemplatesPage />}
      />
      <Route
        path=":carrierId/:formId"
        element={<FormEditorPage />}
      />
      <Route
        path="new"
        element={<NewFormPage />}
      />
    </Routes>
  );
}
